import Vue from 'vue'
import App from './App.vue'
import Vuex from 'vuex'
import VueObserveVisibility from 'vue-observe-visibility'

import './registerServiceWorker'
import router from './router'
import './assets/tailwind.css'
import store from '@/store'

Vue.config.productionTip = false

Vue.use(Vuex)
Vue.use(VueObserveVisibility) // used for tabel scroll indicators

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
